window['__zone_symbol__PASSIVE_EVENTS'] = ['wheel', 'touchstart', 'touchmove'];
